export enum HMSRoomUpdate {
  ROOM_MUTED = 'ROOM_MUTED',
  ROOM_UNMUTED = 'ROOM_UNMUTED',
  SERVER_RECORDING_STATE_UPDATED = 'SERVER_RECORDING_STATE_UPDATED',
  RTMP_STREAMING_STATE_UPDATED = 'RTMP_STREAMING_STATE_UPDATED',
  BROWSER_RECORDING_STATE_UPDATED = 'BROWSER_RECORDING_STATE_UPDATED',
  HLS_STREAMING_STATE_UPDATED = 'HLS_STREAMING_STATE_UPDATED',
  HLS_RECORDING_STATE_UPDATED = 'HLS_RECORDING_STATE_UPDATED',
  ROOM_PEER_COUNT_UPDATED = 'ROOM_PEER_COUNT_UPDATED',
  TRANSCRIPTIONS_UPDATED = 'TRANSCRIPTIONS_UPDATED',
}
